module.exports = __webpack_public_path__ + "img/W-AS3485016.2bb17446.jpg";